import { ActionType, createAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { DTO } from './types'

export const setChatFiltersAction = createAction('@chat/SET_CHAT_FILTERS')<DTO>()

const success = (state: ChatState, action: ActionType<typeof setChatFiltersAction>): ChatState => ({
  ...state,
  chatFilters: { ...state.chatFilters, ...action.payload.chatFilters }
})

export const setChatFiltersHandle = { asyncAction: setChatFiltersAction, success }
